define(['underscore', 'edge/platform/base/BaseCtrl'], (_, BaseCtrl) => {
    // added '$rootScope' *Princy
    const fn = ($filter, $scope, $rootScope, $stateParams, $state, submissionViewModel, ModalService, PrefillService, $q, StateUtils, InMemorySession) => {
        const ctrl = Object.create(BaseCtrl);
        const flowModel = StateUtils.activeDataForState(true).flowModel;
        const submissionVM = submissionViewModel();
        $scope.submissionVM = submissionVM;
        const paModel = $scope.submissionVM.draftData.lobs.personalAuto.value;
        const accountHolder = $scope.submissionVM.value.getAccountHolderPerson();
        const navFrom = flowModel.navigatingFromStep();
        const flowSteps = flowModel.steps;
        const currentStepIndex = _.findIndex(flowSteps, step => step.name === flowModel.currentStep.name);
        $scope.page = {
            drivers: {},
            vehicles: {}
        };
        // added vehicleFlagPrefillArray flag *Princy
        $scope.vehicleFlagPrefillArray = [];
        $scope.driverFlagPrefillArray = [];
        //YearLicenced,LicenseNumber,Accidents,Violations are no longer mandatory parameters

        function addDriver(data) {
            var isDriverAdded = false;
            if (typeof data.drivers !== 'undefined' && data.drivers.length > 0) {
                var primaryDriver = paModel.createDriver(accountHolder);
                primaryDriver.isPrefilledDriver = true;
                angular.forEach(data.drivers, function (driver) {
                    if (isPrimaryDriver(driver)) {
                        primaryDriver.gender = driver.gender;
                        primaryDriver.licenseNumber = driver.licenseNumber;
                        primaryDriver.licenseState = driver.licenseState;
                        primaryDriver.accidents = '0';
                        primaryDriver.violations = '0';
                        primaryDriver.isPrefilledDriver = true;
                        $scope.driverFlagPrefillArray.push(primaryDriver.tempID);
                    } else {
                        const addr = submissionVM.draftData.policyAddress.value;
                        const newPerson = submissionVM.value.createPerson({
                            primaryAddress: addr,
                            isPrefilledDriver: true
                        });
                        
                        const newDriver = paModel.createDriver(newPerson);
                        newDriver.person.firstName = driver.firstName;
                        newDriver.person.middleName = driver.middleName;
                        newDriver.person.lastName = driver.lastName;
                        var d2 = angular.isDefined(driver.dateOfBirth) ? new Date(driver.dateOfBirth) : undefined;
                        if (angular.isDefined(d2)) { d2.setHours(0, 0, 0, 0) };
                        newDriver.dateOfBirth = {
                            "year": angular.isDefined(d2) ? d2.getFullYear().toString() : '',
                            //devendra commented
                            //"month": angular.isDefined(d2) ? (d2.getMonth() + 1).toString() : '',
                            "month": angular.isDefined(d2) ? d2.getMonth().toString() : '',
                            "day": angular.isDefined(d2) ? d2.getDate().toString() : ''
                        };
                        // added below code for age: *Princy//
                        newDriver.age = ctrl.getAge(newDriver)
                        newDriver.gender = driver.gender;
                        newDriver.licenseNumber = driver.licenseNumber;
                        newDriver.licenseState = driver.licenseState;
                        newDriver.accidents = '0';
                        newDriver.violations = '0';
                        newDriver.isPrefilledDriver = true;
                        
                        // added below code for rootscope: *Princy//
                        $rootScope.isPrefilledDriver =true;
                        $scope.driverFlagPrefillArray.push(driver.tempID);
                    }


                });
                isDriverAdded = true;
            }
            return isDriverAdded;

        }

        function isPrimaryDriver(driver) {
            const person = accountHolder;
            const d1 = new Date(person.dateOfBirth.year, person.dateOfBirth.month, person.dateOfBirth.day);
            const d2 = new Date(driver.dateOfBirth);
            d2.setHours(0, 0, 0, 0);
            if (driver.firstName.toLowerCase() === person.firstName.toLowerCase() &&
                driver.lastName.toLowerCase() === person.lastName.toLowerCase() &&
                d1.getTime() == d2.getTime()
            ) { return true; }
            return false;
        }
        function addVehicles(data) {
            var isVehicleAdded = false;
            if (typeof data.vehicles !== 'undefined' && data.vehicles.length > 0) {
                angular.forEach(data.vehicles, function (vehicle) {
                    var newVehicle = paModel.createVehicle(accountHolder);
                    newVehicle.paType = vehicle.pAType;
                    newVehicle.tmpPaType = newVehicle.paType;
                    newVehicle.vin = vehicle.vin;
                    $scope.vehicleFlagPrefillArray.push(vehicle.vin) // added Vin Flag *Princy
                    newVehicle.year = vehicle.modelYear;
                    newVehicle.make = vehicle.make;
                    newVehicle.model = vehicle.model;
                    newVehicle.isGpaQuote = true;
                    if ('motorcycle_aaa' === vehicle.pAType) {
                        newVehicle.cCs = vehicle.cCs;
                        newVehicle.series = vehicle.series;
                        newVehicle.costNew = {
                            "amount": undefined
                        };
                        newVehicle.costNew.amount = vehicle.basePrice;
                        newVehicle.bodyStyle = vehicle.bodyStyle;
                    }
                    if ('auto' === vehicle.pAType) {
                        newVehicle.bodyStyle = vehicle.bodyStyle;
                        newVehicle.cylinder = vehicle.engineCyl;
                        //newVehicle.costNew.amount = vehicle.priceNewSymbolCd;
                        newVehicle.comprehensiveSymbolCd = vehicle.comprehensiveSymbolCd;
                        newVehicle.collisionSymbolCd = vehicle.collisionSymbolCd;
                        newVehicle.twoDgVSRSymbol = vehicle.twoDgVSRSymbol;
                        newVehicle.abs = vehicle.abs;
                        newVehicle.antiTheft = vehicle.antiTheft;
                        newVehicle.restrInd = vehicle.restrInd;
                        newVehicle.vehicleSurchargeCd = vehicle.vehicleSurchargeCode;
                        newVehicle.bodyType = vehicle.bodyType;
                        newVehicle.paAntiLockBrakes = vehicle.paAntiLockBrakes;
                        newVehicle.paPassiveRestraint = vehicle.paPassiveRestraint;
                        newVehicle.paAntiTheft = vehicle.paAntiTheft;
                    }
                    newVehicle.isPrefilledVehicle = true;
                });
                // added array vehicle *Princy
                $rootScope.prefillVehiclesArray =  $scope.vehicleFlagPrefillArray;
                $rootScope.prefillDriversArray =  $scope.driverFlagPrefillArray;
                isVehicleAdded = true;
            }
            return isVehicleAdded;
        }

        function navigatingFromDriversPage() {
            if (typeof navFrom.index !== 'undefined' &&
                parseInt(navFrom.index) > currentStepIndex) {
                return true;
            }
            return false;
        }


        ctrl.init = () => {
            const quoteID = submissionVM.quoteID.value;
            var goToNext = false;
            var prefillReq = {
                "submissionNumber": quoteID,
                "isFromPriorPolicy": false
            };
            if (paModel.drivers.length === 0) { //If there are no drivers and this is the first visit, initialise a new driver and also fill in the data obtained from service
                // Getting Prefill details from factory - INC0019969

                //INC2762580 Remove LN Service Call
                //    flowModel.next(submissionVM, true);
                //Un-commenting below part for Data Prefill *Princy
                var prefillResponseFromFactory = InMemorySession.getPrefillData();
                if ((prefillResponseFromFactory != null) && (typeof prefillResponseFromFactory === 'object') &&
                    (typeof prefillResponseFromFactory.drivers !== 'undefined' || typeof prefillResponseFromFactory.vehicles !== 'undefined')) {

                    const driverAdded = addDriver(prefillResponseFromFactory);
                    const vehicleAdded = addVehicles(prefillResponseFromFactory);
                    updatePage(paModel,prefillResponseFromFactory)
                } else {

                    flowModel.next(submissionVM, true);
                }
                // Commented below part for INC0019969
                /*var responsePromise = PrefillService.getDriverVehiclePrefillData(prefillReq);
                ModalService.showProgressDialog('quoteandbind.controllers.Please wait', responsePromise);
                responsePromise.then(function (response) {
                    if (typeof response === 'object' &&
                        (typeof response.drivers !== 'undefined' || typeof response.vehicles !== 'undefined')) {
                        const driverAdded = addDriver(response);
                        const vehicleAdded = addVehicles(response);
                        updatePage(paModel)
                    } else {
                        flowModel.next(submissionVM, true);
                    }
                }, function (response) {
                    flowModel.next(submissionVM, true);
                })*/

            } else {
                var isPageUpdated = updatePage(paModel,null);
                if (!isPageUpdated) {
                    navigateFromPage();
                }
            }
        };

        function navigateFromPage() {
            /*if(navigatingFromDriversPage()){
                flowModel.previous(submissionVM);
            }else{*/
            flowModel.next(submissionVM, true);
            //}
        }

        function updatePage(paModel,prefillResponseFromFactory) {
            $scope.page.drivers = _.filter(paModel.drivers, function (item) {
                if (typeof item.isPrefilledDriver !== 'undefined' && item.isPrefilledDriver) {
                    return item;
                }
            });
            if(prefillResponseFromFactory){
                $scope.page.drivers.forEach((obj) => {
                    const ind = prefillResponseFromFactory.drivers.findIndex(driver => {
                        return driver.firstName == obj.person.firstName && driver.lastName == obj.person.lastName
                    });
                    if (obj.dateOfBirth.year == '' && obj.dateOfBirth.month == '' && obj.dateOfBirth.day == '' && !_.isUndefined(prefillResponseFromFactory.drivers[ind].dateOfBirth)) {
                        //const x = InMemorySession.decryptData(prefillResponseFromFactory.drivers[ind].eNCDateOfBirth).split(' ')[0].split('-');
                        const x = prefillResponseFromFactory.drivers[ind].dateOfBirth.split(' ')[0].split('-');
                        obj['dateOfBirth']['year'] = parseInt(x[0]);
                        obj['dateOfBirth']['month'] = parseInt(x[1])-1;
                        obj['dateOfBirth']['day'] = parseInt(x[2]);
                    }
                });
            }
            $scope.page.vehicles = _.filter(paModel.vehicles, function (item) {
                if (typeof item.isPrefilledVehicle !== 'undefined' && item.isPrefilledVehicle) {
                    return item;
                }
            });
            return ($scope.page.drivers.length > 0 || $scope.page.vehicles.length > 0);
        }


        ctrl.removeVehicle = function (index) {
            var vehicle = $scope.page.vehicles[index];
            //var name = this.make || '';
            var name = vehicle.year || '';
            if (this.make) {
                if (name) {
                    name += ' ';
                }
                name += this.make;
            }
            if (vehicle.model) {
                if (name) {
                    name += ' ';
                }
                name += vehicle.model;
            }

            const confirmationMsg = {
                key: 'quoteandbind.pa.controllers.PAVehicleDetailsCtrl.RemoveConfirmationMsg',
                args: { vehicle: name }
            };
            ModalService.showWarning('quoteandbind.pa.controllers.PAVehicleDetailsCtrl.Remove vehicle?', confirmationMsg, '',
                $filter('translate')('quoteandbind.pa.controllers.PAVehicleDetailsCtrl.Yes'),
                'gw-btn-primary',
                $filter('translate')('quoteandbind.pa.controllers.PAVehicleDetailsCtrl.No'))
                .result.then(function () {

                    paModel.removeVehicle(vehicle);
                    updatePage(paModel,null);
                });
        }

        ctrl.removeDriver = function (index) {
            var driver = $scope.page.drivers[index];
            var name = driver.person.firstName + ' ' + driver.person.lastName;
            const msg = {
                key: 'quoteandbind.pa.controllers.PADriverDetailsCtrl.DriverRemovalMsg',
                args: { driver: name }
            };

            ModalService.showWarning(
                'quoteandbind.pa.controllers.PADriverDetailsCtrl.Remove driver?', msg, '',
                $filter('translate')('quoteandbind.pa.controllers.PADriverDetailsCtrl.Yes'), 'gw-btn-primary',
                $filter('translate')('quoteandbind.pa.controllers.PADriverDetailsCtrl.No'))
                .result.then(function () {
                    paModel.removeDriver(driver);
                    updatePage(paModel,null);
                });

        }


        ctrl.getAge = function (driver) {
            if(driver.dateOfBirth){
                localDate = driver.dateOfBirth
            }else if(driver.eNCDateOfBirth){
                let getDate = string => (([year, month, day]) => ({ year, month, day }))(string.split('-'));
                let temDob = InMemorySession.decryptData(driver.eNCDateOfBirth).split(' ')[0];
                localDate = getDate(temDob);
            }
            var year = parseInt(localDate.year);
            if (isNaN(year)) return '';
            var month = parseInt(localDate.month) - 1;
            var day = parseInt(localDate.day);
            var today = new Date();
            var birthDate = new Date(year, month, day);
            var age = today.getFullYear() - birthDate.getFullYear();
            var m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
            return age;
        }

        ctrl.next = function (form) {
            form.submitted = true;
            flowModel.next(submissionVM);
        };
        ctrl.previous = function () {
            flowModel.previous(submissionVM);
        };
        ctrl.cancel = function () {
            flowModel.cancel(submissionVM);
        };

        ctrl.continueAction = function (form) {
            ctrl.next(form);
        };


        return ctrl.create($scope);
    };
    // added '$rootScope' *Princy
    fn.$inject = ['$filter', '$scope','$rootScope', '$stateParams', '$state', 'submissionViewModel', 'ModalService', 'PrefillService', '$q', 'StateUtils', 'InMemorySession'];

    return fn;
});



/** WEBPACK FOOTER **
 ** ./app/customer/js/src/edge/quoteandbind/pa/controllers/DriverVehiclePrefilledInfoCtrl.js
 **/